export default __webpack_public_path__ + "static/media/styled.fedb2926.png";